module.exports = __webpack_public_path__ + "img/t4-blue.208229e5.png";